import type { components } from "@/api-schema";
import { DetailTabGrid } from "@/components/detail-page/_components/tab/detail-tab-grid";
import { Briefcase, Building2, GraduationCap, MapPin, Tag, Users } from "lucide-react";
import type { ReactElement } from "react";
import { useTranslation } from "react-i18next";
import { SystemInfo } from "../../_components/system-info";
import { mergeAndFilterBranches } from "./_helpers/merge-and-filter-branches";

type User = components["schemas"]["User"];

export function OrganizationTab({ user }: { user: User }): ReactElement {
  const { t } = useTranslation(["masterdata", "common"]);
  const branches = mergeAndFilterBranches(user.mainBranch, user.branches);

  return (
    <DetailTabGrid>
      <SystemInfo
        label={t("common:Company")}
        values={user.companies?.map((company) => company.name)}
        icon={<Building2 className="text-muted-foreground h-4 w-4" />}
      />
      <SystemInfo
        label={t("common:Brand")}
        values={user.brands?.map((brand) => brand.name)}
        icon={<Tag className="text-muted-foreground h-4 w-4" />}
      />
      <SystemInfo
        label={t("common:Branch")}
        values={branches.map((branch) => branch.name)}
        icon={<MapPin className="text-muted-foreground h-4 w-4" />}
      />
      <SystemInfo
        label={t("common:Department")}
        values={user.departments?.map((department) => department.name)}
        icon={<Users className="text-muted-foreground h-4 w-4" />}
      />
      <SystemInfo
        label={t("common:Occupation")}
        values={user.occupations?.map((occupation) => occupation.name)}
        icon={<GraduationCap className="text-muted-foreground h-4 w-4" />}
      />
      <SystemInfo
        label={t("masterdata:Function")}
        values={user.jobFunctions?.map((jobFunction) => jobFunction.name)}
        icon={<Briefcase className="text-muted-foreground h-4 w-4" />}
      />
    </DetailTabGrid>
  );
}
